import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./tabs.html";
class Tabs extends LightningElement {
  constructor(...args) {
    super(...args);
    this.title = void 0;
    this._options = [];
    this.activePanelClass = 'axwp-tabs__panel--active';
    this.slots = null;
  }
  get options() {
    return this._options;
  }
  set options(value) {
    if (Array.isArray(value)) {
      this._options = value;
      return;
    }
    this._options = JSON.parse(value);
  }
  get tabs() {
    return this._options.map((option, index) => ({
      ...option,
      active: index === 0,
      tabIndex: index === 0 ? '0' : '-1',
      tabPanelId: `tab-panel-${option.identifier}`,
      tabPanelClass: `axwp-tabs__panel${index === 0 ? ' ' + this.activePanelClass : ''}`
    }));
  }
  deactivateCurrentTab() {
    const currentTab = this.template.querySelector('.axwp-tabs__list button.axwp-tabs__item-button[aria-selected="true"]');
    if (!currentTab) {
      return;
    }
    currentTab.setAttribute('aria-selected', 'false');
    currentTab.setAttribute('tabindex', '-1');
    this.deactivateCurrentPanel();
  }
  deactivateCurrentPanel() {
    this.slots?.forEach(slot => {
      if (slot instanceof HTMLElement) {
        const panel = slot.querySelector(`.${this.activePanelClass}`);
        if (panel) {
          panel.classList.remove(this.activePanelClass);
          panel.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }
  activateTab(tab) {
    this.deactivateCurrentTab();
    this.activatePanel(tab);
    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');
    tab.focus();
  }
  activatePanel(tab) {
    const panelId = tab.getAttribute('aria-controls');
    if (!panelId) {
      return;
    }
    this.slots?.forEach(slot => {
      if (slot instanceof HTMLElement) {
        const panel = slot.querySelector(`#${panelId}`);
        if (panel) {
          panel.classList.add(this.activePanelClass);
          panel.setAttribute('aria-hidden', 'false');
        }
      }
    });
  }
  handleTabClick(event) {
    const clickedTab = event.target;
    const clickedTabData = this.tabs.find(tab => tab.identifier === clickedTab.id);
    if (!clickedTabData) {
      return;
    }
    this.activateTab(clickedTab);
    this.analyticsSourceProps = {
      disabled: false,
      callToAction: {
        label: clickedTabData.label,
        name: clickedTabData.label,
        url: ''
      }
    };
  }
  handleTabListKeyDown(event) {
    const direction = event.key;
    const next = 'ArrowRight';
    const prev = 'ArrowLeft';
    const home = 'Home';
    const end = 'End';
    if (![next, prev, end, home].includes(direction)) {
      return;
    }
    event.preventDefault();
    const allTabs = this.template.querySelectorAll('.axwp-tabs__list button.axwp-tabs__item-button');
    const currentFocusedTab = event.target;
    const endIndex = allTabs.length - 1;
    const currentFocusedTabIndex = Array.from(allTabs).indexOf(currentFocusedTab);
    let targetIndex = direction === prev ? currentFocusedTabIndex - 1 : currentFocusedTabIndex + 1;
    if (direction === prev && currentFocusedTabIndex === 0 || direction === end) {
      targetIndex = endIndex;
    } else if (direction === next && currentFocusedTabIndex === endIndex || direction === home) {
      targetIndex = 0;
    }
    allTabs[targetIndex].focus();
  }
  handleAnalytics(event) {
    event.detail.elementType = 'tab';
    event.detail.button = this.analyticsSourceProps;
  }
  updateTabsListAlignment() {
    const tabsList = this.template.querySelector('.axwp-tabs__list');
    if (!tabsList) {
      return;
    }
    if (tabsList.scrollWidth > tabsList.clientWidth) {
      tabsList.style.justifyContent = 'flex-start';
      return;
    }
    tabsList.style.justifyContent = 'center';
  }
  updateTabsListContainerWidth() {
    const tabsWrapper = this.template.querySelector('.axwp-tabs');
    const tabsListContainer = this.template.querySelector('.axwp-tabs__list-container');
    const tabsList = this.template.querySelector('.axwp-tabs__list');
    if (!tabsWrapper || !tabsListContainer || !tabsList) {
      return;
    }
    const tabsListContentWidth = Array.from(tabsList.children).reduce((totalWidth, child) => {
      return totalWidth + child.offsetWidth;
    }, 0);
    if (tabsListContentWidth > tabsWrapper.clientWidth) {
      tabsListContainer.classList.add('alignfull');
      return;
    }
    tabsListContainer.classList.remove('alignfull');
  }
  handleResize() {
    this.updateTabsListContainerWidth();
    this.updateTabsListAlignment();
  }
  renderedCallback() {
    // Get the injected slot elements.
    const slot = this.template.querySelector('slot[name="tab-contents"]');
    if (slot && slot.assignedElements().length > 0) {
      this.slots = slot.assignedElements({
        flatten: true
      });
    }
    this.handleResize();
    window.addEventListener('resize', this.handleResize.bind(this));
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize.bind(this));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Tabs, {
  publicProps: {
    title: {
      config: 0
    },
    options: {
      config: 3
    }
  },
  publicMethods: ["deactivateCurrentTab", "activateTab"],
  fields: ["_options", "activePanelClass", "slots"]
});
const __lwc_component_class_internal = _registerComponent(Tabs, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;